/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
  /**
   * The latitude of a point in the shape.
   * @type {number}
   * @memberof Coordinate
   */
  lat: number;
  /**
   * The longitude of a point in the shape.
   * @type {number}
   * @memberof Coordinate
   */
  lon: number;
}

/**
 * Check if a given object implements the Coordinate interface.
 */
export function instanceOfCoordinate(value: object): value is Coordinate {
  if (!("lat" in value) || value["lat"] === undefined) return false;
  if (!("lon" in value) || value["lon"] === undefined) return false;
  return true;
}

export function CoordinateFromJSON(json: any): Coordinate {
  return CoordinateFromJSONTyped(json, false);
}

export function CoordinateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Coordinate {
  if (json == null) {
    return json;
  }
  return {
    lat: json["lat"],
    lon: json["lon"],
  };
}

export function CoordinateToJSON(json: any): Coordinate {
  return CoordinateToJSONTyped(json, false);
}

export function CoordinateToJSONTyped(
  value?: Coordinate | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lat: value["lat"],
    lon: value["lon"],
  };
}
